import React, { useState } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { Collection } from '@helpers/show_page_helpers';
import BulkShareModal from '../bulk_actions/BulkShareModal';


const InternalShareBar = ({ allAssetKeys }) => {
  const pageAssetCount = allAssetKeys.size;
  const unfilteredRedirect = window.location.href.split("?")[0];
  const digest = queryString.parse(window.location.search).digest;
  const openModal = queryString.parse(window.location.search).show_edit_share_mode === "true";

  const [showShareModal, toggleShareModal] = useState(openModal);

  const shareEditPermission = ['admin', 'owner', 'collaborator'].includes(BF.fx.role()) || BFG.currentUser.su;
  const renderShareEditLink = () => (
    shareEditPermission ? (
      <div className="link" onClick={() => toggleShareModal(true)}>
        <span className="bff-edit" aria-hidden="true" /> Edit Share Link
      </div>
    ) : null
  );

  if (digest && pageAssetCount > 0) {
    return (
      <div className="internal-share-bar">
        { showShareModal ? (
          <BulkShareModal
            closeModal={() => toggleShareModal(false)}
            selectedAssetKeys={allAssetKeys}
          />
        ) : ''}

        <h3> Share Link showing {pageAssetCount}
          {` asset${pageAssetCount > 1 ? 's' : ''} `}
          from {`${Collection.key ? "Collection" : "Brandfolder"}`}
        </h3>
        {renderShareEditLink()}
        <a href={unfilteredRedirect} className="link">
          View all assets in {`${Collection.key ? "Collection" : "Brandfolder"}`}
        </a>
      </div>
    );
  }

  return null;
};

InternalShareBar.propTypes = {
  allAssetKeys: PropTypes.instanceOf(Set).isRequired
};

export default InternalShareBar;
